import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxzZWN1cmUlMjBkaWdpdGFsJTIwbmV0d29yayUyMGFic3RyYWN0fGVufDB8fHx8MTc4MzE5NDM2MHww&ixlib=rb-4.1.0&q=85";

export const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden bg-[#040812]"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Secure digital network"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#040812] via-[#040812]/85 to-[#040812]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#040812] via-transparent to-[#040812]/40" />
        <div className="absolute inset-0 grid-bg opacity-30" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-10 pb-20 md:pb-28 pt-32">
        <div className="max-w-4xl">
          <div className="reveal flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-red-500" />
            <span className="overline">Enterprise Technology · Est. 2022</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="reveal reveal-delay-1 font-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-[84px] leading-[1.02] tracking-tighter font-light"
          >
            Engineered for the{" "}
            <span className="text-red-500">institutions</span>
            <br />
            that cannot afford to fail.
          </h1>

          <p className="reveal reveal-delay-2 mt-8 text-slate-400 text-base md:text-lg leading-relaxed max-w-2xl font-body">
            Sriman Solutions delivers enterprise-grade software, AML/KYC
            compliance audits, autonomous AI sales infrastructure and secure
            business process services — built for banks, fintechs and regulated
            operators that demand absolute operational control.
          </p>

          <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to="/contact"
              data-testid="hero-cta-button"
              className="group inline-flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white font-medium px-7 py-4 rounded-sm transition-all duration-200"
            >
              Schedule a Consultation
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
            <Link
              to="/services"
              data-testid="hero-secondary-button"
              className="group inline-flex items-center gap-2 text-white text-sm border border-white/20 hover:border-white px-6 py-4 rounded-sm transition-colors"
            >
              Explore capabilities
              <ArrowRight
                size={14}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
          </div>

          <div className="reveal reveal-delay-4 mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl border-t border-white/10 pt-8">
            {[
              { k: "100%", v: "Bootstrapped" },
              { k: "24/7", v: "Global delivery" },
              { k: "SOC 2", v: "Compliance aligned" },
              { k: "0", v: "External investors" },
            ].map((s) => (
              <div key={s.v}>
                <div className="font-display text-white text-2xl md:text-3xl tracking-tight">
                  {s.k}
                </div>
                <div className="font-mono text-[10px] text-slate-500 tracking-[0.22em] uppercase mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 hidden lg:flex items-center gap-2 text-slate-500 text-xs font-mono tracking-widest">
        <ShieldCheck size={14} className="text-red-500" />
        <span>SECURE · SOVEREIGN · SELF-HOSTED</span>
      </div>
    </section>
  );
};

export default HeroSection;
